import React from 'react';
import PropTypes from 'prop-types';
import { APP_STOREFRONT_FEATURES } from 'constants/app';

import './storefront.scss';

export default class StorefrontNewAppHighlights extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
  };

  renderFeature(feature) {
    const featureDef = APP_STOREFRONT_FEATURES.find(({ id }) => id === feature);
    if (!featureDef) {
      return null;
    }

    return (
      <>
        <div className="storefront-apps-feature-title">{featureDef.label}</div>
        <div className="storefront-apps-feature-description">
          {featureDef.description}
        </div>
      </>
    );
  }

  render() {
    const { app } = this.props;

    if (!app.features?.length) {
      return null;
    }

    return (
      <div className="storefront-apps-features">
        {app.features.map((feature, index) => (
          <div key={index} className="storefront-apps-feature-item">
            {this.renderFeature(feature)}
          </div>
        ))}
      </div>
    );
  }
}
